import {
    ActivityIndicator,
    Image,
    TouchableWithoutFeedback,
    View
} from "../../../custom-packages/react-native-components-in-react/react-native-components-in-react";
import ImageIcon from "../../../assets/custom-icons/ImageIcon";
import AppConfig from "../../../AppConfig";
import React, {useRef, useState} from "react";
import {useSelector} from "react-redux";
import UpgradeModal from "../Subscription/UpgradeModal";
import Styles from "../../../Styles";


const MenuLogo = ({menuID, imageLq, style, imageStyle, onImageChanged}) => {
    const auth = useSelector(state => state.Auth);

    const inputFile = useRef()

    const [loading, setLoading] = useState(false)
    const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false)

    const changeFoodImage = async () => {
        if (
            auth.sub
            && (
                auth.sub.code === AppConfig.SUB_BASIC
                ||
                auth.sub.code === AppConfig.SUB_STANDARD
                ||
                auth.sub.code === AppConfig.SUB_PREMIUM
            )
        ) {
            inputFile.current.click();
        } else {
            setIsUpgradeModalOpen(true)
        }
    }

    return <View style={{...style}}>
        {
            loading
                ?
                <ActivityIndicator size={60}/>
                :
                imageLq
                    ?
                    <TouchableWithoutFeedback
                        onPress={changeFoodImage}
                        style={{borderRadius: '50%', width: '100%'}}
                    >
                        <View>
                            <Image
                                source={{uri: imageLq}}
                                className={'table-image'}
                                style={{
                                    borderRadius: '50%',
                                    ...imageStyle
                                }}
                            />
                        </View>
                    </TouchableWithoutFeedback>
                    :
                    <TouchableWithoutFeedback
                        onPress={changeFoodImage}
                    >
                        <View
                            style={{
                                borderRadius: '50%',
                                justifyContent: 'center',
                                flexDirection: 'row',
                                backgroundColor: Styles.basicBackgroundColor.color,
                                ...imageStyle
                            }}
                            className={'table-image'}
                        >
                            <View style={{justifyContent: 'center'}}>
                                <ImageIcon color={'white'} size={25}/>
                            </View>
                        </View>
                    </TouchableWithoutFeedback>
        }
        <input
            ref={inputFile}
            style={{display: 'none'}}
            type="file"
            name="item"
            accept=".png,.jpg,.jpeg"
            onChange={async (event) => {
                try {
                    setLoading(true)

                    const toBase64 = file => new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = () => resolve(reader.result);
                        reader.onerror = error => reject(error);
                    });

                    const image = await toBase64(event.target.files[0]);

                    const response = await fetch(AppConfig.URL + "/Menu/UploadLogo/" + menuID, {
                        method: 'POST',
                        body: JSON.stringify({
                            Image: image,
                        }),
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'Authorization': auth.token
                        }
                    });

                    const r = await response.json();

                    if (r.success) {
                        onImageChanged(image)
                    }
                } catch (e) {

                } finally {
                    setLoading(false)
                }
            }}
        />
        <UpgradeModal
            visible={isUpgradeModalOpen}
            onRequestClose={() => {
                setIsUpgradeModalOpen(false)
            }}
            plan={AppConfig.SUB_BASIC}
        />
    </View>
}

export default MenuLogo;